import { render, staticRenderFns } from "./SMSEditor.vue?vue&type=template&id=5c48d590&scoped=true&"
import script from "./SMSEditor.vue?vue&type=script&lang=js&"
export * from "./SMSEditor.vue?vue&type=script&lang=js&"
import style0 from "./SMSEditor.vue?vue&type=style&index=0&id=5c48d590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48d590",
  null
  
)

export default component.exports